import React, { useEffect, useState }  from 'react';
import { getCurrentUser, fetchVerifyToken } from "../reducers/login";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Loader from '../elements/Loader';

const UnauthRoute = (props) => {

    const findComponent = () => {
        if (!localStorage.getItem('token') && !props.currentUser) {
            return <Route {...props}/>
        }else if (localStorage.getItem('token') && !props.currentUser){
            props.verifyToken();
            return <Loader/>
        }else{
            return <Redirect to='/'/>
        }
    }

    const [component, setComponent] = useState(findComponent())
    
    useEffect(()=>{
        setComponent(findComponent());
        // eslint-disable-next-line
    }, [props.currentUser, props.component])

    return component
}

const mapStateToProps = (state) => ({
    currentUser: getCurrentUser(state),
  });

  const actions = (dispatch, props) => ({
    verifyToken: bindActionCreators(fetchVerifyToken, dispatch),
});

export default connect(mapStateToProps, actions)(UnauthRoute);